import React, { useState,useEffect, useRef } from "react";
import { Input, Form, Button,Divider,Row,Col,Spin } from "antd";
import { useDispatch} from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.less";
import { normalActionTypes } from "@/redux/actions/quantisAction";
import { weevilTrakResetPassword, weevilTrakSendVerificationCode } from "@/util/http/WeevilTrak";
import { updateCommonErrorMessage, updateCommonSuccessMessage, updateCommonWarnMessage } from "@/redux/actions/weevilTrakAction";

const ForgetPassword = ()=>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading,useLoading] = useState(false);
    const [countDown,useCountDown] = useState(60);
    const [count,useCount] = useState(undefined);
    const [form] = Form.useForm();
    const timerRef = useRef<any>(null);

    // const [email,setEmail]=useState("");
    // const [password,setPassword]=useState("");
    // const [verificationCode,setVerificationCode]=useState("");
    const [loadding,setLoadding] = useState(false);


    const runGetCaptchaCountDown = () => {
        let counts:any = countDown || 59;
        useCount(counts);
        timerRef.current = setInterval(() => {
            counts -= 1;
            useCount(counts);
            if (counts === 0) {
                clearInterval(timerRef.current);
            }
        }, 1000);
    };
    const onVerificationButtonClick = async()=>{
        setLoadding(true);
        try{
            const email = form?.getFieldValue("email");
            if(email){
                const res = await weevilTrakSendVerificationCode(email);
                runGetCaptchaCountDown();
                if(res.data=== true){
                    dispatch(updateCommonSuccessMessage("Verification Code sent successfully."));
                }else{
                    dispatch(updateCommonErrorMessage("Email account is not exist"));
                }
            }else{
                dispatch(updateCommonWarnMessage("The email field is required."));
            }
        }
        catch(error){
            dispatch(updateCommonErrorMessage(error?.response?.data));
        }
        finally{
            setLoadding(false);
        }

    };
    const changPassword = async()=>{
        setLoadding(true);
        try{
            const email = form?.getFieldValue("email");
            const password = form?.getFieldValue("password");
            const verificationCode = form?.getFieldValue("verificationCode");
            if (email.trim() && verificationCode?.trim() && password?.trim()){
                const res = await weevilTrakResetPassword({
                    email: email,
                    verificationCode: verificationCode,
                    newPassword:password,
                    confirmPassword: password
                });
                if(res.data){
                    dispatch(updateCommonSuccessMessage(res?.data));
                    navigate("/weeviltrak/login");
                }else{
                    dispatch(updateCommonWarnMessage(res?.data));
                }
            }
        }
        catch(error){
            dispatch(updateCommonErrorMessage(error?.response?.data));
        }
        finally{
            setLoadding(false);
        }

    };
    return(
        <div className="forget-password-style">
            <Spin spinning={loadding} size="large">
                <Form
                    name="basic"
                    labelCol={{ span:10 }}
                    form={form}
                    layout="vertical"
                    autoComplete="off"
                    style={{
                        marginTop: "50px",
                        padding: "20px 30px",
                        // border: "1px solid rgb(217, 217, 217)",
                        border: "1px solid rgb(89, 185, 72)",
                        borderRadius: "5px"
                    }}
                >
                    <Divider>
                        <p>Retrieve Password</p>
                    </Divider>

                    <Form.Item
                        name="email"
                        label="Email address"
                        rules={[
                            { required: true, message: "Please input your Email address!" },
                            {pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,message: "Incorrect format!",max:50}
                        ]}
                    >
                        <Input placeholder="Email"
                            onChange={(e)=>{
                                // setEmail(e.target.value);
                            }} />
                    </Form.Item>


                    <Form.Item>
                        <Row gutter={8}>
                            <Col span={14}>
                                <Form.Item
                                    name="verificationCode"
                                    label="Verification Code"
                                    rules={[{ required: true, message: "Please Enter Verification Code from Email!" }]}
                                >
                                    <Input
                                        placeholder="Verification Code"
                                        onChange={(e) => {
                                            // 当用户开始输入验证码时
                                            if (e.target.value && timerRef.current) {
                                                clearInterval(timerRef.current); // 停止倒计时
                                                useCount(undefined); // 恢复按钮的可点击状态
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={10}>
                                <Button
                                    type="primary"
                                    className={undefined == count || 0 == count ? "verification-code-button" : "disabled-verification-code-button"}
                                    onClick={onVerificationButtonClick}
                                    loading={loading}
                                    disabled={
                                        undefined != count && 0 != count
                                    }
                                >
                                    {undefined == count || 0 == count ? "Verification Code" : count+"second"}
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="New Password"
                        rules={[{ required: true, message: "Please input your Password!" },
                            ()=>({
                                validator(_,value){
                                    const rx = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,18}$/;
                                    if (rx.test(value)){
                                        return Promise.resolve();
                                    }else{
                                        return Promise.reject(new Error(`The password strength is not enough. The password must contain letters and numbers, 
                        and the length is greater than 8 and less than 30`));
                                    }
                                }
                            })
                        ]}
                    >
                        <Input.Password placeholder="new password"
                            onChange={(e)=>{
                                // setPassword(e.target.value);
                            }} />
                    </Form.Item>
                    <Form.Item
                        name="confirm"
                        label="Confirm Password"
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: "Please confirm your password!",
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("password") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("The two passwords that you entered do not match!"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="change-password-button" onClick={changPassword}>
                        Change Password
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>

        </div>
    );
};

export default ForgetPassword;
